<template>
    <v-container>
        <v-flex xs12 sm12 md8 lg8 xl6 style="margin:auto">
            <v-card>
                <v-card-text>
                    <v-form>
                        <h4 class="primary--text">{{this.$t('lang.user.profile')}}</h4>
                        <div style="text-align: center">
                            <i-upload :label="$t('lang.teacher.avatar')"
                                      v-model="user.avatarId"
                                      file-type="avatar" :multifile="false"
                                      v-validate="'required'"
                                      name="avatarId"
                                      :data-vv-as="$t('lang.teacher.avatar')"
                                      :error-messages="errors.first('avatarId')"
                            />
                        </div>
                        <v-text-field type="text" :label="$t('lang.user.username') + '*'" v-model.trim="user.userName"
                                      name="username"
                                      key="userName"
                                      maxLength="20"
                                      autofocus :disabled="user.id != null"
                                      :data-vv-as="$t('lang.user.username')"
                                      :error-messages="errors.first('username')" readonly
                        ></v-text-field>
                        <v-btn color="red" dark @click="changePassword">
                            <v-icon>security</v-icon>&nbsp;
                            {{$t('lang.user.changePassword')}}</v-btn>
                        <v-btn color="info" dark @click="changeNotify" v-if="$store.state.auth.user.role==2">
                            <v-icon>notifications_active</v-icon>
                            &nbsp;Thông báo
                        </v-btn>
                        <v-text-field type="text" :label="$t('lang.user.fullName') + '*'" v-model.trim="user.fullName"
                                      name="fullName"
                                      key="fullName"
                                      v-validate="'required'" maxLength="50"
                                      :error-messages="errors.first('fullName')"
                                      :data-vv-as="$t('lang.user.fullName')"
                        ></v-text-field>
                        <v-text-field type="text" :label="$t('lang.user.email') + '*'" v-model.trim="user.email"
                                      name="email"
                                      key="email"
                                      v-validate="user.role==4||user.role==1?'required|email|emailUnique':'email|emailUnique'"
                                      maxLength="50" :disabled="disableEmail"
                                      :data-vv-as="$t('lang.user.email')"
                                      :error-messages="errors.first('email')"
                        ></v-text-field>

                        <v-text-field type="text" :label="$t('lang.user.phone') + '*'" v-model.trim="user.phone"
                                      name="phone"
                                      key="phone"
                                      v-validate="{ required: user.role==4||user.role==1, regex: /^[0-9()-]*$/im }"
                                      maxLength="20"
                                      :disabled="disablePhone"
                                      :data-vv-as="$t('lang.user.phone')"
                                      :error-messages="errors.first('phone')"
                        ></v-text-field>
                        <i-datepicker v-model="user.birthday" :label="$t('lang.user.birthday')"
                                      name="birthday"
                                      key="birthday"
                        />
                        <v-radio-group v-model="user.gender"
                                       v-validate="'required'"
                                       name="gender"
                                       key="gender"
                                       :error-messages="errors.first('gender')"
                                       data-vv-as="Giới tính"
                                       label="Giới tính">
                            <v-radio
                                    key="maleGender"
                                    label="Nam"
                                    :value="true"
                            ></v-radio>
                            <v-radio
                                    key="femaleGender"
                                    label="Nữ"
                                    :value="false"
                            ></v-radio>
                        </v-radio-group>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="yoprimary" dark @click="handleSubmit">
                        {{$t('lang.common.save')}}
                    </v-btn>
                    <v-btn color="cancel" @click="back">
                        {{$t('lang.common.back')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-container>
</template>

<script>
    import {router} from "../router";
    import {mapState} from "vuex";
    import {Validator} from "vee-validate";
    import {CrudService} from "@/services";
    import {roleService} from "@/services";
    import axios from "axios";
    import {message} from "@/shared/message";
    import IUpload from "../components/form/Upload";
    import IDatepicker from "../components/form/DatePicker";

    export default {
        name: "Profile",
        components: {IDatepicker, IUpload},
        data() {
            return {
                submitted: false,
                user: {
                    status: 1
                },
                lstProvice:[],
                profile: {
                    'workingAt': '',
                    'experience': '',
                    'email': '',
                    'yoTarget': '',
                    'cvId': null
                },
                disablePhone:false,
                disableEmail:false
            };
        },
        computed: mapState({
            loading: state => state.common.loading,
        }),
        methods: {
            handleSubmit(e) {
                this.submitted = true;
                //console.log("user:", this.user);
                this.$validator.validate().then(valid => {
                    if (valid) {
                        CrudService.of('user').updateItem(this.user).then(() => {
                            //message.success(`Update Profile Success!`);
                            if (this.user.role == 1 || this.user.role == 4) {
                                this.profile.teacherName = this.user.fullName;
                                this.profile.avatarId = this.user.avatarId;
                                this.profile.email = this.user.email;
                                this.profile.phone = this.user.phone;
                                this.profile.userId = this.user.userId;
                                axios.post(process.env.VUE_APP_API_URL + "/user/updateTeacherProfile", this.profile).then(
                                    data => {
                                        if (data.success) {
                                            message.success(this.$t('lang.common.update_success'));
                                            this.back();
                                        } else {
                                            message.error(this.$t(data.message));
                                        }
                                    },
                                    error => {
                                        message.error(error);

                                    }
                                )
                            } else {
                                message.success(this.$t('lang.common.update_success'));
                                this.back();
                            }
                        });
                    } else {
                        message.error("Bạn nhập thiếu thông tin hoặc thông tin không đúng định dạng");
                    }
                });
                return false;
            },
            changePassword: function () {
                this.$router.push("/changePass");
            },

            changeNotify: function(){
                this.$router.push("/changeNotify");
            },

            getCategoryData: function () {
                axios.post(process.env.VUE_APP_API_URL + "/category/listForSelect?type=PROVINCE").then(
                    data => {
                        this.lstProvice = data;
                    },
                    error => {

                    }
                )
            },

            getProvinceName: function () {
                for (let i = 0; i < this.lstProvice.length; i++) {
                    if (this.lstProvice[i].categoryId == this.profile.provinceId) {
                        this.profile.provinceName = this.lstProvice[i].categoryName;
                        break;
                    }
                }
            },
            back() {
                this.$router.go(-2);
            }
        },
        created() {
            /*
                        //console.log(this.$store.state.auth.user);
                        //console.log(this.profile);
            */
            if (this.$store.state.auth.user.userId) {
                //console.log(this.$store.state.auth.user);
                CrudService.of('user').getItem(this.$store.state.auth.user.userId).then(user => {
                    ////console.log(user);
                    user.password = "";
                    this.user = user;
                    this.initUsername = user.userName;
                    this.initEmail = user.email;
                    if(this.user.phone != null && this.user.phone != ''){
                        this.disablePhone = true;
                    }
                    if(this.user.email != null && this.user.email != ''){
                        this.disableEmail = true;
                    }
                });
                axios.post(process.env.VUE_APP_API_URL + "/class/teacherInfo").then(
                    data => {
                        if (data != null && data != "") {
                            this.profile = data;
                        } else {
                            this.profile = {};
                        }
                        //console.log(this.profile);
                    },
                    error => {
                        //console.log(error);
                    }
                );
                this.getCategoryData();
            }
        },
        mounted() {
            let me = this;
            const usernameUnique = (value) => {
                if (me.initUsername == value) {
                    return true;
                }
                return axios.get(`${process.env.VUE_APP_API_URL}/user/validate-username?username=${value}`).then((data) => {
                    //debugger;
                    return {
                        valid: data.valid,
                        data: {
                            message: data.message
                        }
                    };
                });
            };

            const emailUnique = (value) => {
                if (me.initEmail == value) {
                    return true;
                }
                return axios.get(`${process.env.VUE_APP_API_URL}/user/validate-email?email=${value}`).then((data) => {
                    return {
                        valid: data.valid,
                        data: {
                            message: data.message
                        }
                    };
                });
            };

            Validator.extend("usernameUnique", {
                validate: usernameUnique,
                getMessage: (field, params, data) => {
                    return this.$t('lang.user.usernameExist');
                }
            });

            Validator.extend("emailUnique", {
                validate: emailUnique,
                getMessage: (field, params, data) => {
                    return this.$t('lang.user.emailExist');
                }
            });

            if (this.$route.params.id) {
                this.$refs.password.focus();
            }
        }
    };
</script>
